import AccountGroupSpecification from "../accountSpecification/AccountGroupSpecification.js";
import AccountIntervalSpecification from "../accountSpecification/AccountIntervalSpecification.js";
import AccountNumberListSpecification from "../accountSpecification/AccountNumberListSpecification.js";
import AndSpecification from "./AndSpecification.js";
import DimensionSpecification from "../dimensionSpecification/DimensionSpecification.js";
import IntervalAccountGroup from "../chartOfAccounts/IntervalAccountGroup.js";
import ModelFactory from "../ModelFactory.js";
import NotSpecification from "./NotSpecification.js";
import OrSpecification from "./OrSpecification.js";
import SingleAccountSpecification from "../accountSpecification/SingleAccountSpecification.js";

/**
 * `SpecificationFactory` is responsible for materializing all kinds of specifications.
 */
class SpecificationFactory extends ModelFactory {
	allClasses() {
		return [
			AndSpecification,
			NotSpecification,
			OrSpecification,
			AccountGroupSpecification,
			AccountIntervalSpecification,
			AccountNumberListSpecification,
			DimensionSpecification,
			SingleAccountSpecification,
		];
	}

	parseInterval(intervalString) {
		const intervals = IntervalAccountGroup.parseInterval(intervalString);

		if (intervals.length === 1)
			return this._makeAccountIntervalSpecification(intervals[0]);

		return new OrSpecification({
			specifications: intervals.map((interval) =>
				this._makeAccountIntervalSpecification(interval),
			),
		});
	}

	_makeAccountIntervalSpecification({ start, end }) {
		return new AccountIntervalSpecification({
			interval: `${start}-${end}`,
		});
	}
}

const specificationFactory = new SpecificationFactory();

export default specificationFactory;
